import { render } from "./Goal.vue?vue&type=template&id=0b3925be&ts=true"
import script from "./Goal.vue?vue&type=script&lang=ts"
export * from "./Goal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__